import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { CompanyProvider } from './context/CompanyContext';
import { ServiceProvider } from './context/ServiceContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import { NotifProvider } from './context/NotifContext';
import Login from './pages/Login';
import Onboarding from './pages/Onboarding';
import Dashboard from './pages/Dashboard';
import Leads from './pages/Leads';
import Team from './pages/Team';
import Finance from './pages/Finance';
import Analytics from './pages/Analytics';
import CalendarPage from './pages/Calendar';
import Projects from './pages/Projects';
import Settings from './pages/Settings';
import Clients from './pages/Clients';
import EmployeeDashboard from './pages/EmployeeDashboard';
import './index.css';

/* Protected route -- redirects to login if not authenticated */
function Protected({ children, adminOnly }) {
  const { isAuthenticated, user } = useAuth();
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (adminOnly && user.role === 'User') return <Navigate to="/employee" replace />;
  return children;
}

function RootRedirect() {
  const { isAuthenticated, user } = useAuth();
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (user.role === 'User') return <Navigate to="/employee" replace />;
  const done = localStorage.getItem('ryzenos_onboarded');
  if (!done) return <Navigate to="/onboarding" replace />;
  return <Navigate to="/dashboard" replace />;
}

export default function App() {
  return (
    <ThemeProvider>
      <CompanyProvider>
        <ServiceProvider>
          <AuthProvider>
            <NotifProvider>
              <BrowserRouter>
                <Routes>
                  <Route path="/login"      element={<Login />} />
                  <Route path="/onboarding" element={<Protected><Onboarding /></Protected>} />
                  <Route path="/dashboard"  element={<Protected adminOnly><Dashboard /></Protected>} />
                  <Route path="/leads"      element={<Protected adminOnly><Leads /></Protected>} />
                  <Route path="/clients"    element={<Protected adminOnly><Clients /></Protected>} />
                  <Route path="/team"       element={<Protected adminOnly><Team /></Protected>} />
                  <Route path="/finance"    element={<Protected adminOnly><Finance /></Protected>} />
                  <Route path="/analytics"  element={<Protected adminOnly><Analytics /></Protected>} />
                  <Route path="/calendar"   element={<Protected><CalendarPage /></Protected>} />
                  <Route path="/projects"   element={<Protected adminOnly><Projects /></Protected>} />
                  <Route path="/settings"   element={<Protected><Settings /></Protected>} />
                  <Route path="/employee"   element={<Protected><EmployeeDashboard /></Protected>} />
                  <Route path="*"           element={<RootRedirect />} />
                </Routes>
              </BrowserRouter>
            </NotifProvider>
          </AuthProvider>
        </ServiceProvider>
      </CompanyProvider>
    </ThemeProvider>
  );
}
